module.exports = __webpack_public_path__ + "static/orb_of_dragonkind-8ac42bf1820fc052548e6efe7e3e9b14.png";